import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/auth/apiClient';
import { queryKeys } from './queryKeys';
import type { BetreuungspreisRow, BetreuungspreisUpsertBody, UUID } from './types';

/** @deprecated The current backend returns Betreuungspreise per plan, not per Einrichtung. */
export function useBetreuungspreise(_einrichtungId: UUID | null) {
  return useQuery({
    queryKey: ['betreuungspreis', 'einrichtung', 'none'] as const,
    queryFn: async (): Promise<BetreuungspreisRow[]> => [],
    enabled: false,
  });
}

export function useBetreuungspreisePlan(planId: UUID | null) {
  return useQuery({
    queryKey: planId ? queryKeys.betreuungspreis.plan(planId) : ['betreuungspreis', 'plan', 'none'],
    queryFn: async (): Promise<BetreuungspreisRow[]> => {
      if (!planId) return [];
      const res = await apiClient.get<BetreuungspreisRow[]>(`/plan/${planId}/betreuungspreis`);
      return res.data;
    },
    enabled: !!planId,
  });
}

export function useUpsertBetreuungspreis(planId: UUID) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: BetreuungspreisUpsertBody): Promise<BetreuungspreisRow> => {
      const res = await apiClient.put<BetreuungspreisRow>(
        `/plan/${planId}/betreuungspreis`,
        body,
      );
      return res.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.betreuungspreis.plan(planId) });
      void qc.invalidateQueries({ queryKey: queryKeys.snapshot.plan(planId) });
    },
  });
}

export function useDeleteBetreuungspreis(planId: UUID) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: UUID): Promise<void> => {
      await apiClient.delete(`/plan/${planId}/betreuungspreis/${id}`);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.betreuungspreis.plan(planId) });
      void qc.invalidateQueries({ queryKey: queryKeys.snapshot.plan(planId) });
    },
  });
}
